@if (isVisible()) {
  <div
    class="bn-topbar"
    data-e2e="LoggedInAsTopbar">
    <div class="bn-topbar__section">
      <fa-icon icon="circle-user" />
      <span>
        Signed in as
        <span
          class="bn-topbar__emphasis"
          [tooltip]="isSubuser() ? 'Sub User' : 'Main User'"
          >{{ userDetails().FirstName }} {{ userDetails().LastName }}</span
        >
        {{ userDetails().Email }}
      </span>
    </div>
    <span class="bn-topbar__divider"></span>
    @if (!isPartnerSession()) {
      <bn-web-ui-switch
        size="sm"
        tooltip="Blur video and image thumbnails across the dashboard to protect potentially sensitive content"
        [ngModel]="blurThumbnails()"
        (ngModelChange)="onToggleBlurThumbnails($event)">
        <span
          class="bn-topbar__blur-label"
          label-after
          >Blur thumbnails</span
        >
      </bn-web-ui-switch>
      <span class="bn-topbar__divider"></span>
    }
    <div class="bn-topbar__section bn-topbar__section--tight">
      <fa-icon icon="clock" />
      <span
        class="bn-topbar__timer"
        data-e2e="TopbarSessionCountdown"
        >{{ remainingTime() }}</span
      >
      <button
        aria-label="Extend the session and reset the auto-logout timer"
        class="bn-topbar__icon-button"
        data-e2e="TopbarExtendSessionButton"
        tooltip="Extend the session and reset the auto-logout timer"
        type="button"
        (click)="extendSession()">
        <fa-icon icon="arrows-rotate" />
      </button>
    </div>
    <button
      class="bn-topbar__logout bn-topbar__emphasis"
      data-e2e="TopbarLogoutButton"
      type="button"
      (click)="logout()">
      Logout
    </button>
  </div>
}
